(function(){
    console.log('o-formulaire-recherche loaded');
    
    const comp = document.querySelector('.o-formulaire-recherche');
    if(!comp) return;

    const btnOpen = document.querySelectorAll('#js-open-search, .js-open-search');
    const btnClose = document.querySelector('#js-close-search');
    const input = comp.querySelector('input');

    // Ouvrir
    if(btnOpen.length) {
        btnOpen.forEach((button) => button.addEventListener('click', (e) => {
            e.preventDefault();
            comp.classList.add('is-active');
            document.body.classList.add('no-scroll');
            
            // Focus sur l'input après l'animation
            setTimeout(() => {
                if(input) input.focus();
            }, 400);
        }));
    }

    // Fermer
    if(btnClose) {
        btnClose.addEventListener('click', (e) => {
            e.preventDefault();
            close();
        });
    }

    // Fermer avec Escape
    document.addEventListener('keydown', (e) => {
        if(e.key === 'Escape' && comp.classList.contains('is-active')) {
            close();
        }
    });

    // Fermer en cliquant sur le fond
    comp.addEventListener('click', (e) => {
        if(e.target === comp) {
            close();
        }
    });

    function close() {
        comp.classList.remove('is-active');
        document.body.classList.remove('no-scroll');
        if(input) input.value = '';
    }
    
    const boutonSubmit = document.querySelector('#bouton-submit');
    if (input && boutonSubmit) {
        input.addEventListener('input', () => {
            if (input.value.trim().length > 0) {
                boutonSubmit.classList.add('active');
            } else {
                boutonSubmit.classList.remove('active');
            }
        });
    }

}());
